import React, { useState } from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/site/Seo";
import {
  LayoutDashboard, GraduationCap, Package, FileText, Users, ShoppingCart,
  Ticket, Newspaper, Quote, HelpCircle, Settings, ShieldAlert, LogOut, Menu, X, FileStack,
} from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/exams", label: "Exams", icon: GraduationCap, id: "exams" },
  { to: "/admin/products", label: "Test Series", icon: Package, id: "products" },
  { to: "/admin/tests", label: "Tests & Questions", icon: FileText, id: "tests" },
  { to: "/admin/students", label: "Students", icon: Users, id: "students" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, id: "orders" },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket, id: "coupons" },
  { to: "/admin/blog", label: "Blog", icon: Newspaper, id: "blog" },
  { to: "/admin/pages", label: "Custom Pages", icon: FileStack, id: "pages" },
  { to: "/admin/testimonials", label: "Testimonials", icon: Quote, id: "testimonials" },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle, id: "faqs" },
  { to: "/admin/settings", label: "Settings & SEO", icon: Settings, id: "settings" },
  { to: "/admin/system", label: "System", icon: ShieldAlert, id: "system" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const Side = () => (
    <div className="flex flex-col h-full">
      <Link to="/" className="px-5 py-5 flex items-center gap-2"><Logo className="h-7" /></Link>
      <div className="px-5 pb-3 text-[11px] uppercase tracking-widest text-content-muted">Admin Panel</div>
      <nav className="flex-1 px-3 space-y-0.5 overflow-y-auto">
        {LINKS.map((l) => (
          <NavLink key={l.id} to={l.to} end={l.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${l.id}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-ember-soft text-ember" : "text-content-secondary hover:bg-card-hover hover:text-content"}`}>
            <l.icon className="w-4 h-4" /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-line">
        <div className="px-3 pb-2 text-xs text-content-muted truncate">{user?.email}</div>
        <button onClick={() => { logout(); nav("/"); }} data-testid="admin-logout"
          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-content-secondary hover:text-red-400 w-full">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-ink flex">
      <aside className="hidden lg:block w-64 border-r border-line bg-surface fixed inset-y-0 z-30"><Side /></aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-surface border-r border-line"><Side /></div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden glass-nav border-b border-line px-4 h-14 flex items-center justify-between sticky top-0 z-40">
          <button onClick={() => setOpen(true)}><Menu className="w-5 h-5" /></button>
          <span className="text-sm font-medium">Admin</span><span className="w-5" />
        </header>
        <main className="p-4 sm:p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
